import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import Vant from 'vant'
import 'vant/lib/index.css'
import api from './http/api/index.js'

const app = createApp(App);
app.config.globalProperties.$api = api
console.log("main.ts", api)
router.beforeEach((to, from, next) => {
    // 路由发生变化修改页面title
    if (to.meta.title) {
        document.title = String(to.meta.title);
    }
    next();
})

app.use(store).use(router).use(Vant).mount('#app')
